import { axiosInstance } from "../network";
import { API_URL } from "../../constants";
import _ from "lodash";

export default {
  userCreate: (data) => {
    return axiosInstance.post(API_URL.USER, data);
  },

  userEdit: (id, data) => {
    return axiosInstance.patch(`${API_URL.GETALLUSERID}/${id}`, data);
  },
  userUnlock: (id) => {
    return axiosInstance.patch(`${API_URL.USER_UNLOCK}/${id}`, {});
  },
  userUnlockMail: (data) => {
    return axiosInstance.post(`${API_URL.USER_UNLOCK_MAIL}`, data);
  },

  getAllUsers: (page, pageSize, searchparams) => {
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axiosInstance.get(API_URL.GETALLUSER, {
      params: {
        username: filteredParams.username
          ? filteredParams.username.trim()
          : filteredParams.username,
        access_type: filteredParams.access_type
          ? filteredParams.access_type.trim()
          : filteredParams.access_type,
        mobile_number: filteredParams.mobile_number
          ? filteredParams.mobile_number.trim()
          : filteredParams.mobile_number,
        role_uuid: filteredParams.role_uuid
          ? filteredParams.role_uuid.trim()
          : filteredParams.role_uuid,
        status: filteredParams.status
          ? filteredParams.status.trim()
          : filteredParams.status,
        page,
        pageSize,
      },
    });
  },

  getAllRoles: () => {
    return axiosInstance.get(API_URL.ROLECHART);
  },
  getOwnerDetails: () => {
    return axiosInstance.get(API_URL.GETPARENTDETAILS);
  },

  getUserId: (id) => {
    return axiosInstance.get(`${API_URL.USER_GET_ID}/${id}`);
  },

  getUserById: (id) => {
    return axiosInstance.get(`${API_URL.GETALLUSERID}/${id}`);
  },

  userStatusUpdate: (userid, data) => {
    return axiosInstance.patch(`${API_URL.USER_GET}/${userid}`, data);
  },
};
